import {mapActions, mapMutations, mapGetters} from 'vuex';

import {required, alpha, minLength, maxLength} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";

export default {
  name: 'countryGroups.create',
  mixins: [validationMixin],
  data() {
    return {
      payload: {
        prefix: null,
        translations: [],
      },
      currentTranslations: 0,
      validationErrors: {},
    }
  },
  components: {},
  validations: {
    payload: {
      prefix: {
        required,
        alpha,
        minLength: minLength(1)
      },
      translations: {
        $each: {
          title: {
            required,
            minLength: minLength(1),
            maxLength: maxLength(20)
          }
        }
      }
    }
  },
  created() {
    this._applyData();
  },
  mounted() {},
  computed: {
    ...mapGetters({
      isCountryGroupCreating: 'countryGroups/isCountryGroupCreating',
    }),
    ...mapGetters([
      'languages',
    ]),
    prefixErrors() {
      let error = [];
      if (!this.$v.payload.prefix.$dirty) {
        return error;
      }
      if (!this.$v.payload.prefix.required) {
        error.push(this.$t('validationRequired'));
      }
      if (!this.$v.payload.prefix.minLength) {
        error.push(this.$t('validationMin',{count: 1}));
      }
      if (!this.$v.payload.prefix.alpha) {
        error.push(this.$t('validationAlpha'));
      }
      if (this.validationErrors.prefix) {
        this.validationErrors.prefix.forEach((row) => {
          error.push(row);
        })
      }
      return error;
    },
  },
  methods: {
    ...mapActions({
      createCountryGroups: 'countryGroups/COUNTRY_GROUP_REQUEST_CREATE',
    }),
    _applyData() {
      this.payload.translations = this.languages.map(langItem => {
        return {
          locale: langItem.translationKey,
          title: '',
        }
      });
    },
    translationsTitleErrors(index) {
      let error = [];
      if (!this.$v.payload.translations.$each[index].title.$dirty) {
        return error;
      }
      if (!this.$v.payload.translations.$each[index].title.required) {
        error.push(this.$t('validationRequired'));
      }
      if (!this.$v.payload.translations.$each[index].title.minLength) {
        error.push(this.$t('validationMin',{count: 1}));
      }
      if (!this.$v.payload.translations.$each[index].title.maxLength) {
        error.push(this.$t('validationMax',{count: 20}));
      }
      return error;
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let payload = {
          prefix: this.payload.prefix,
        }
        this.payload.translations.forEach(item => {
          payload[item.locale] = {
            title: item.title
          }
        });

        this.createCountryGroups(payload).then(() => {
          this.$toasted.success(this.$t('dataUpdated'));
          this.$router.push({name: 'countryGroups.list'}).catch(()=> {console.log()})
        }).catch(error => {
          if (error.response.status === 422) {
            this.$toasted.error(error.response.data.message);
            this.validationErrors = error.response.data.errors
          }
        });
      }
    }
  }
}
